/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogCloseButton,
    Text,
    Flex,
    Box,
    useStyleConfig,
} from '@chakra-ui/react'
import {AlertIcon} from '../icons/others'
import PropTypes from 'prop-types'

const ConfirmationModal = ({
    title,
    description,
    optionalText,
    isOpen,
    // onPrimaryAction = noop,
    onAlternateAction = noop,
    ...props
}) => {
    const styles = useStyleConfig('ConfirmationModal')

    const handleOnClose = () => {
        onAlternateAction()
    }

    return (
        <AlertDialog
            isOpen={isOpen}
            isCentered
            onClose={handleOnClose}
            // closeOnEsc={false}
            // closeOnOverlayClick={false}
            {...props}
        >
            <AlertDialogOverlay />
            <AlertDialogContent>
                <AlertDialogCloseButton data-testid="close-icon" onClick={handleOnClose} />
                <AlertDialogBody>
                    <Flex {...styles.container}>
                        <Box {...styles.iconContainer}>
                            <AlertIcon {...styles.alertIcon} />
                        </Box>
                        <Flex {...styles.textContainer}>
                            <Text {...styles.text} textStyle="body-xlarge">
                                {title}
                            </Text>
                            <Text {...styles.text} textStyle="body-medium">
                                {description}
                            </Text>
                            {optionalText && (
                                <Text {...styles.text} textStyle="body-xsmall">
                                    {optionalText}
                                </Text>
                            )}
                        </Flex>
                    </Flex>
                </AlertDialogBody>
            </AlertDialogContent>
        </AlertDialog>
    )
}

ConfirmationModal.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    optionalText: PropTypes.string,
    isOpen: PropTypes.bool,
    // onPrimaryAction: PropTypes.func,
    onAlternateAction: PropTypes.func,
}

export default ConfirmationModal
